import { t } from "@/i18n-js/instance";
import { ItemLabel } from "@/react/components/shared/uikit/Form/Item/ItemLabel";
import { Form } from "@circle-react-shared/uikit/Form";
import { localeRoot } from "../../constants";
import { RowSidebar } from "../components/RowSidebar";

interface CalloutColorFieldProps {
  name: string;
}

export const CalloutColorField = ({ name }: CalloutColorFieldProps) => (
  <RowSidebar className="items-center justify-between">
    <ItemLabel
      label={t([localeRoot, "builder.price_callouts.fields.callout_color"])}
    />
    <Form.ColorPickerV2
      name={name}
      data-testid="paywall-callout-color-picker"
    />
  </RowSidebar>
);
